import { useQuery } from "@tanstack/react-query";
import axiosManager from "../services/axiosManager";

export const useGetSingleStudent = (studentId) => {
    const {
        isLoading, data: student, error,
        refetch, isRefetching,
    } = useQuery({
        queryKey: [`student/${studentId}`],
        queryFn: () => axiosManager.get$(`/parent/api/students/${studentId}`).then((response) => response?.data),
        retry: 0,
        cacheTime: 0,
        keepPreviousData: true,
        enabled: !!studentId,
        select: (data) => {
            const firstLanguage = (data?.languages || []).find((item) => item.isFirstLanguage);
            const nationality = (data?.nationalities || [])?.[0];

            return ({
                ...(data || {}),
                firstLanguage: firstLanguage ? { id: firstLanguage.isoCode, label: firstLanguage.name } : undefined,
                nationality: nationality ? { id: nationality.isoCode, label: nationality.name } : undefined,
            });
        },
    });

    return {
        isLoading,
        isRefetching,
        student: student || {},
        error,
        refetch,
    };
};
